import React from 'react';
import './feedbackPreview.css';
import formattedDate from '../../utils/formattedDate.js';

const FeedbackPreview = ({feedback, updateFeedbackState}) => {

  const handleClick = () => {
    updateFeedbackState({highlightedFeedback: feedback.id});
  };

  return (
    <div onClick={handleClick} className={`FeedbackPreviewPage Status${feedback.status[0].status.replace(' ','')}`}>
      <div className="TopLine">
        <h2><b>{feedback.app}</b> - <b>{feedback.type}</b> - <span className={`${feedback.priority}PriorityText`}><b>{`${feedback.priority} Priority`}</b></span></h2>
      </div>
      <div className="SecondLine">
        <h4>Submitted by <b>{feedback.user}</b> - {formattedDate(feedback.date)}</h4>
      </div>
      <div className="Body">
        <span>{`${feedback.body.length < 510 ? feedback.body : `${feedback.body.slice(0, 500)}...`}`}</span>
      </div>
      <div className="Updates">
                Status: <span>{feedback.status[0].status}</span> - Updates: <span>{feedback.status.length - 1}</span>
      </div>
    </div>
  );

};

export default FeedbackPreview;


// WEBPACK FOOTER //
// ./src/components/content/feedback/feedbackList/feedbackPreview/feedbackPreview.js